function FormatChecker(file) {

  if (!/\.jpg|\.jpeg|\.png|\.pdf$/.test(file.name.toLowerCase())) {
    return true;
  } else {
    return false;
  }
}
export default FormatChecker;
